<div class="container mt-1 mb-5">
  <div class="row">
    <div class="col-md-2 p-0 mt-3">
      <app-left-side-bar-menu
        [menuAtivo]="menuAtivo"
        [itensMenu]="grupos"
        (selecionaGrupo)="buscaMateriais($event)"
      >
      </app-left-side-bar-menu>
    </div>
    <div class="col-md-10 pr-1 pt-4">
      <app-material-marketing-list
        [grupo]="grupoAtual"
        [itens]="itens"
      ></app-material-marketing-list>
    </div>
  </div>
</div>
